import React, { useEffect, useState } from 'react';
import Navbar from '../layout/Navbar';
import Footer from '../layout/Footer';
import {
  USER_SEARCH_ENDPOINT,
  ACCOUNT_SEARCH_ENDPOINT,
  CUSTOMER_ASSIGN_ENDPOINT,
  CUSTOMER_REMOVE_ENDPOINT
} from '../../config/api';

function AccountAccess() {
  const [users, setUsers] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [accessMap, setAccessMap] = useState({});

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const res = await fetch(USER_SEARCH_ENDPOINT);
      const data = await res.json();
      if (res.ok && Array.isArray(data)) {
        setUsers(data);
        fetchAccounts(data);
      }
    } catch (err) {
      console.error('Error fetching users', err);
    }
  };

  const fetchAccounts = async (userList = []) => {
    try {
      const res = await fetch(ACCOUNT_SEARCH_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({})
      });
      const data = await res.json();

      if (res.ok && Array.isArray(data)) {
        setAccounts(data);
        const map = {};
        data.forEach(account => {
          userList.forEach(user => {
            const key = `${user.id}_${account.id}`;
            if (account.has_access === 1) {
              map[key] = true;
            }
          });
        });
        setAccessMap(map);
      }
    } catch (err) {
      console.error('Error fetching accounts', err);
    }
  };

  const handleToggleAccess = async (userId, accountId) => {
    const key = `${userId}_${accountId}`;
    const currentlyAssigned = !!accessMap[key];
    setAccessMap(prev => ({ ...prev, [key]: !currentlyAssigned }));

    try {
      const endpoint = currentlyAssigned ? CUSTOMER_REMOVE_ENDPOINT : CUSTOMER_ASSIGN_ENDPOINT;
      const res = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: userId, customer_id: accountId })
      });
      const result = await res.json();
      if (!res.ok || !result.success) {
        alert(result.error || 'Failed to update access');
        setAccessMap(prev => ({ ...prev, [key]: currentlyAssigned }));
      }
    } catch (err) {
      console.error('API error', err);
      alert('Server error');
      setAccessMap(prev => ({ ...prev, [key]: currentlyAssigned }));
    }
  };

  return (
    <>
      <Navbar />
      <div className="container mt-5">
        <div className="card shadow border-0 rounded-4">
          <div className="card-header bg-primary text-white rounded-top-4">
            <h4 className="mb-0">Account Access Management</h4>
          </div>
          <div className="card-body">
            <div className="accordion" id="userAccessAccordion">
              {users.map((user, idx) => (
                <div className="accordion-item" key={user.id}>
                  <h2 className="accordion-header" id={`heading-${idx}`}>
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#collapse-${idx}`}
                    >
                      {user.name} ({user.email})
                    </button>
                  </h2>
                  <div
                    id={`collapse-${idx}`}
                    className="accordion-collapse collapse"
                    data-bs-parent="#userAccessAccordion"
                  >
                    <div className="accordion-body">
                      <ul className="list-group">
                        {accounts.map(account => {
                          const key = `${user.id}_${account.id}`;
                          return (
                            <li className="list-group-item d-flex justify-content-between align-items-center" key={account.id}>
                              {account.account_name}
                              <input
                                type="checkbox"
                                checked={!!accessMap[key]}
                                onChange={() => handleToggleAccess(user.id, account.id)}
                              />
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default AccountAccess;
